import React from 'react';
import { Text } from '@fluentui/react';
import Theme from '../Theme';

const renderPreformattedBlocks = (lines) => {
  const rendered = [];
  let codeLines = null;
  let keyCounter = 0;
  const nextKey = (prefix) => {
    const key = `${prefix}-${keyCounter}`;
    keyCounter += 1;
    return key;
  };

  lines.forEach((line) => {
    const trimmed = line.trim();
    if (trimmed === '<pre>') {
      if (codeLines) {
        codeLines.push(line);
        return;
      }
      codeLines = [];
      return;
    }

    if (trimmed === '</pre>') {
      if (!codeLines) {
        rendered.push(
          <Text block key={nextKey('text')}>
            {line}
          </Text>,
        );
        return;
      }

      rendered.push(
        <pre className={Theme.styles.codeBlock} key={nextKey('code')}>
          <code>{codeLines.join('\n')}</code>
        </pre>,
      );
      codeLines = null;
      return;
    }

    if (codeLines) {
      codeLines.push(line);
      return;
    }

    rendered.push(
      <Text block key={nextKey('text')}>
        {line}
      </Text>,
    );
  });

  if (codeLines) {
    rendered.push(
      <pre className={Theme.styles.codeBlock} key={nextKey('code')}>
        <code>{codeLines.join('\n')}</code>
      </pre>,
    );
  }

  return rendered;
};

export default {
  renderPreformattedBlocks,
};
